import { fetchConfigs } from '@infl-ts/ui-advocate-setup';
import { dehydrate, QueryClient } from '@tanstack/react-query';
import type { NextPageContext } from 'next';

export const prefetchAppData = async (ctx: NextPageContext) => {
  const { req, res } = ctx;
  if (!req || !res)
    throw new Error('Unreachable: req and res should always be present on server-side');

  const {
    headers: { host, cookie }
  } = req;
  const queryClient = new QueryClient();

  await queryClient.prefetchQuery({
    queryKey: ['siteConfigData'],
    queryFn: ({ meta }) => fetchConfigs(meta ?? {}),
    meta: { host, cookie }
  });

  return dehydrate(queryClient);
};
